// useful for when using logic dependant on if an attribute exists, and that
// it's not falsey.
// further: https://github.com/carwow/carwow-theme/pull/5209
export function hasTruthyAttribute (attributes, attributeName) {
  if (!attributes.hasAttribute(attributeName)) return false

  const value = attributes.getAttribute(attributeName)

  if (typeof value === 'boolean') return value
  if (value === 'false') return false

  return true
}
